import { createTheme } from "@mui/material/styles";
import * as React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";

const CustomTheme = () => {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");

  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          primary: {
            main: "#2c5b94",
          },
          secondary: {
            main: "#142e4c",
          },
        },
        typography: {
          fontFamily: "var(--font-alliance)",
        },
        components: {
          MuiOutlinedInput: {
            styleOverrides: {
              input: {
                "&:-webkit-autofill": {
                  WebkitBoxShadow: "0 0 0 100px var(--primary-weak) inset",
                  WebkitTextFillColor: "var(--text-primary)",
                },
              },
            },
          },
        },
      }),
    [prefersDarkMode]
  );

  return { defaultTheme: theme };
};

export default CustomTheme;
